import PropTypes from "prop-types";

import iconsBookmarkChecked from "../../assets/svg/icons-bookmark-checked.svg";

import iconsBookmarkUnchecked from "../../assets/svg/icons-bookmark-unchecked.svg";

const StarBookmark = ({ value }) => {
  return value ? (
    <img
      height={24}
      width={24}
      src={iconsBookmarkChecked}
      alt="bookmark_star_true"
    />
  ) : (
    <img
      height={24}
      width={24}
      src={iconsBookmarkUnchecked}
      alt="bookmark_star_false"
    />
  );
};

StarBookmark.propTypes = {
  value: PropTypes.bool.isRequired,
};

StarBookmark.defaultProps = {
  value: false,
};

export default StarBookmark;
